import React from 'react'
import { Box, Typography, SxProps, Theme } from '@mui/material'
import type { FeatureListItemType } from '../../../../../src/types/ui'
import { formlessColors } from '@zuto/theme/src/mui/Colors'

type FeatureListItemProps = FeatureListItemType & {
  sx?: SxProps<Theme>
  iconWrapperSx?: SxProps<Theme>
  titleSx?: SxProps<Theme>
  descriptionSx?: SxProps<Theme>
}

const FeatureListItem: React.FC<FeatureListItemProps> = ({
  icon,
  title,
  description,
  sx,
  iconWrapperSx,
  titleSx,
  descriptionSx
}) => {
  const Icon = icon.component

  return (
    <Box
      sx={{
        borderRadius: '18px',
        padding: '14px 20px',
        backgroundColor: '#ffffff',
        boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
        border: '1px solid #E5E7EB',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        boxSizing: 'border-box',
        ...sx
      }}
    >
      <Box
        sx={{
          width: '36px',
          height: '36px',
          borderRadius: '12px',
          backgroundColor: icon.bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 5,
          flexShrink: 0,
          ...iconWrapperSx
        }}
      >
        <Icon sx={{ fontSize: '22px', color: icon.color }} />
      </Box>

      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            marginBottom: 1,
            ...titleSx
          }}
          variant="bodyLarge"
          component="p"
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: formlessColors.textMuted,
            ...descriptionSx
          }}
          variant="bodyMedium"
          component="p"
        >
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default FeatureListItem
